





















import { CameraImageActionsTypes } from "@/store/modules/CameraImage/types";
import { store } from "@/store/store";
import Utils from "@/utils/utils";
import Vue from "vue";

export default Vue.extend({
  name: "DeviceDownload",
  components: {},
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async downloadZip() {
      this.loading = true;
      const result = await store.dispatch(CameraImageActionsTypes.DOWNLOAD_CAMERA_IMAGE_ZIP);
      const date = Utils.transformDateToYMDHMS(new Date());
      var link = document.createElement("a");
      link.href = "data:application/zip;base64," + result;
      link.download = `${date.replaceAll(":", "_").replace(" ", "_")}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loading = false;
    }
  },
  computed: {},
  watch: {}
});
